import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import { History } from 'history';

import { getGhaInfo, setDestinationGha } from '../../store/actions/ghaAction';
import { receiveError, receiveSuccess } from '../../store/actions/notificationAction';
import { offlineRfsClearData } from '../../store/actions/offlineRfsAction';

import offlineRfsRemote from '../../api/offlineRfsRemote';
import forwarderRemote from '../../api/forwarderRemote';

import RfsSetup from './RfsSetup';
import ProcessBarContainer from '../processBar/ProcessBarContainer';

import ApiResponse from '../../models/ApiResponse';
import ResponseError from '../../models/ResponseError';
import User, { UserRoleType } from '../../models/User';
import OfflineRfsModel, { Point, OfflineRfsOrder } from '../../models/OfflineRfs';
import ForwarderModel from '../../models/ForwarderAwb';
import commonStyles from '../common/common.module.css';

import { PO_SCHEMA } from '../../utils/offlineOrder';
import moment from 'moment';
import AirlineType from '../../models/AirlineType';
import GhaModel from '../../models/Gha';
import { baseUrl } from '../../api/baseUrl';

interface RfsSetupProps {
  history: History;
  receiveError: (error: ResponseError) => void;
  userRole: UserRoleType;
  match: { isExact: boolean; params: { id: string }; path: string; url: string; };
  clearOfflineRfsClearData: () => void;
  gha: GhaModel;
  user: User;
  getGhaInfo: Function;
};

const ALL: boolean= true;
const initialErrors =  {
  rfsNumber: '',
  org: '',
  dst: '',
  scheduleDate: moment(),
  scheduleTime: moment(),
  scheduleArrDate: moment(),
  scheduleArrTime: moment(),
  truckType: '',
  equipment: '',
  pickUp: '',
  dropOff: '',
  airline: -1
};

interface RfsSetupState {
  offlineRfs: OfflineRfsModel;
  errors: OfflineRfsModel;
  pickupPoints: Array<Point>;
  dropOffPoints: Array<Point>;
  requestId?: string;
  code: string;
  number: string;
  didUpdates: number;
  isPickUpDialogOpen: boolean;
  isDropOffDialogOpen: boolean;
  pickUp: Point;
  dropOff: Point;
  orderInfo: OfflineRfsOrder;
  isEditMode: boolean;
  flights: Array<AirlineType>;
};

class RfsContainer extends PureComponent <RfsSetupProps, RfsSetupState> {

  state: RfsSetupState = {
    offlineRfs: {
      rfsNumber: '',
      org: '',
      dst: '',
      scheduleDate: moment(),
      schedule_date: moment().format('YYYYMMDD'),
      scheduleTime: moment(),
      schedule_time: moment().format('HHmm'),
      scheduleArrDate: moment(),
      schedule_arr_date: moment().format('YYYYMMDD'),
      scheduleArrTime: moment(),
      schedule_arr_time: moment().format('HHmm'),
      truckType: '',
      equipment: '',
      pickUp: '',
      dropOff: '',
      pickUpName: '',
      dropOffName: '',
      fwdId: -1,
      airline: -1
    },
    pickUp: {
      name: '',
      addr1: '',
      addr2: '',
      city: '',
      state: '',
      zip: '',
    },
    dropOff: {
      name: '',
      addr1: '',
      addr2: '',
      city: '',
      state: '',
      zip: ''
    },
    errors: initialErrors,
    pickupPoints:[],
    dropOffPoints:[],
    requestId: '',
    code: '',
    number: '',
    didUpdates: 0,
    isPickUpDialogOpen: false,
    isDropOffDialogOpen: false,
    orderInfo: PO_SCHEMA,
    isEditMode: false,
    flights: []
  };

  componentDidMount(): void {

    this.loadPoints('pickUp');
    this.loadPoints('dropOff');
    this.props.clearOfflineRfsClearData();
    if(this.props.gha.info.location && !this.state.isEditMode) {
      const offlineRfs: OfflineRfsModel = { ...this.state.offlineRfs };
      offlineRfs.org = this.props.gha.info.location;
      this.setState({ offlineRfs });
    }
    this.getFlights();

    const orderNumberId: number = parseInt(this.props.match.params.id);
    this.props.getGhaInfo(this.props.user.gha_id);
    
    if(orderNumberId) {

      offlineRfsRemote.getOfflineRfsOrderDetails(orderNumberId).then((resp: ApiResponse<OfflineRfsOrder>) => {

        const orderInfo: OfflineRfsOrder | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;
  
        if (orderInfo) {
          const offlineRfs: OfflineRfsModel = { ...this.state.offlineRfs };
          offlineRfs.id =  orderInfo.id;
          offlineRfs.rfsNumber = orderInfo.rfs_number;
          offlineRfs.org = orderInfo.org;
          offlineRfs.dst = orderInfo.dst;
          offlineRfs.scheduleDate = moment(orderInfo.schedule_date);
          offlineRfs.schedule_date = orderInfo.schedule_date;
          offlineRfs.scheduleTime = moment(orderInfo.schedule_time, 'HH:mm');
          offlineRfs.schedule_time = orderInfo.schedule_time;
          offlineRfs.scheduleArrDate = moment(orderInfo.schedule_arr_date);
          offlineRfs.schedule_arr_date = orderInfo.schedule_arr_date;
          offlineRfs.scheduleArrTime = moment(orderInfo.schedule_arr_time, 'HH:mm');
          offlineRfs.schedule_arr_time = orderInfo.schedule_arr_time;
          offlineRfs.truckType = orderInfo.truck_type;
          offlineRfs.equipment = orderInfo.equipment;
          offlineRfs.airline = orderInfo.airline;
          offlineRfs.pickUp = orderInfo.id_pickup.toString();
          var pickupResult = this.state.pickupPoints.find(obj => { return obj.id == orderInfo.id_pickup });
          offlineRfs.pickUpName = (pickupResult)? pickupResult.name: '';
          offlineRfs.dropOff = orderInfo.id_dropoff.toString();
          var dropoffResult = this.state.dropOffPoints.find(obj => { return obj.id == orderInfo.id_dropoff });
          offlineRfs.dropOffName = (dropoffResult) ? dropoffResult.name: '';

          this.setState({ offlineRfs, isEditMode: true });
        }
        
        if (error) {
          this.props.receiveError(error);
        }
      });
    }

    this.loadForwarders();
  }

  componentDidUpdate(prevProps: RfsSetupProps): void {
    if(prevProps.gha.info.location !== this.props.gha.info.location) {
      if(this.props.gha.info.location && !this.state.isEditMode) {
        const offlineRfs: OfflineRfsModel = { ...this.state.offlineRfs };
        offlineRfs.org = this.props.gha.info.location;
        this.setState({ offlineRfs });
      }
    }
   
  };

  loadForwarders = (): void => {

    forwarderRemote.getForwarders({ all: ALL, type: 'rfs' }).then((resp: ApiResponse<Array<ForwarderModel>>) => {

      const forwarders: Array<ForwarderModel> | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (forwarders) {
        const offlineRfs: OfflineRfsModel = { ...this.state.offlineRfs };
        offlineRfs.fwdId =  forwarders[0].id;
        this.setState ({ offlineRfs });
      }

      if (error) {
        this.props.receiveError(error);
      }
    });
  }

  loadPoints = (type: string): void => {

    let isPick: boolean = (type==='pickUp')? true : false;
    offlineRfsRemote.getPoints(isPick).then((resp: ApiResponse<Array<Point>>) => {

      if(type==='pickUp') {
        const pickupPoints: Array<Point> | undefined = resp.result;
        if (pickupPoints) {
          this.setState({ pickupPoints });
        }
      } else {
        const dropOffPoints: Array<Point> | undefined = resp.result;
        if (dropOffPoints) {
          this.setState({ dropOffPoints });
        }
      }
      const error: ResponseError | undefined = resp.error;

      if (error) {
        this.props.receiveError(error);
      }
    });
  };

  handleChange = (propertyName: string, event: any): void => {

    const offlineRfs: OfflineRfsModel = { ...this.state.offlineRfs };
    const pickUp: Point = { ...this.state.pickUp };
    const dropOff: Point = { ...this.state.dropOff };

    switch (propertyName) {
      case 'rfsNumber':
        offlineRfs.rfsNumber = event.target.value;
        this.setState ({ offlineRfs });
      break;
      case 'org':
        if(event.target.value.length > 3) {
          return;
        }
        offlineRfs.org = event.target.value;
        this.setState ({ offlineRfs });
      break;
      case 'dst':
        if(event.target.value.length > 3) {
          return;
        }
        offlineRfs.dst = event.target.value;
        this.setState ({ offlineRfs });
      break;
      case 'flight':
        offlineRfs.airline = Number(event.target.value);
        this.setState ({ offlineRfs });
      break;
      case 'scheduleDate':
        offlineRfs.scheduleDate = event;
        offlineRfs.schedule_date = event.format('YYYYMMDD');
        this.setState ({ offlineRfs });
      break;
      case 'scheduleTime':
        offlineRfs.scheduleTime = event;
        offlineRfs.schedule_time = event.format('HHmm');
        this.setState ({ offlineRfs });
      break;
      case 'arrivalDate':
        offlineRfs.scheduleArrDate = event;
        offlineRfs.schedule_arr_date = event.format('YYYYMMDD');
        this.setState ({ offlineRfs });
      break;
      case 'arrivalTime':
        offlineRfs.arrivalTime = event;
        offlineRfs.schedule_arr_time = event.format('HHmm');
        this.setState ({ offlineRfs });
      break;
      case 'truckType':
        offlineRfs.truckType = event.target.value;
        this.setState ({ offlineRfs });
      break;
      case 'equipment':
        offlineRfs.equipment = event.target.value;
        this.setState ({ offlineRfs });
      break;
      case 'pickUp':
        offlineRfs.pickUp = event.target.value;
        var result = this.state.pickupPoints.find(obj => { return obj.id == parseInt(event.target.value) })
        offlineRfs.pickUpName = (result)? result.name: '';
        this.setState ({ offlineRfs });
      break;
      case 'dropOff':
        offlineRfs.dropOff = event.target.value;
        var result = this.state.dropOffPoints.find(obj => { return obj.id == parseInt(event.target.value) })
        offlineRfs.dropOffName = (result)? result.name: '';
        this.setState ({ offlineRfs });
      break;
      case 'puName':
        pickUp.name = event.target.value;
        this.setState ({ pickUp });
      break;
      case 'puAddr1':
        pickUp.addr1 = event.target.value;
        this.setState ({ pickUp });
      break;
      case 'puAddr2':
        pickUp.addr2 = event.target.value;
        this.setState ({ pickUp });
      break;
      case 'puCity':
        pickUp.city = event.target.value;
        this.setState ({ pickUp });
      break;
      case 'puState':
        pickUp.state = event.target.value;
        this.setState ({ pickUp });
      break;
      case 'puZip':
        pickUp.zip = event.target.value;
        this.setState ({ pickUp });
      break;
      case 'doName':
        dropOff.name = event.target.value;
        this.setState ({ dropOff });
      break;
      case 'doAddr1':
        dropOff.addr1 = event.target.value;
        this.setState ({ dropOff });
      break;
      case 'doAddr2':
        dropOff.addr2 = event.target.value;
        this.setState ({ dropOff });
      break;
      case 'doCity':
        dropOff.city = event.target.value;
        this.setState ({ dropOff });
      break;
      case 'doState':
        dropOff.state = event.target.value;
        this.setState ({ dropOff });
      break;
      case 'doZip':
        dropOff.zip = event.target.value;
        this.setState ({ dropOff });
      break;
      default: break;
    }

  }

  getFlights = (): void => {
    const dest: string = this.state.offlineRfs.dst;
    if(dest === '' || dest.length < 3) {
      return;
    }
    offlineRfsRemote.getDestinationAirlines(dest).then((resp: ApiResponse<any>) => {
      const success: any | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (success) {
        this.setState({ flights: resp.result })
      }

      if (error) {
        this.props.receiveError(error);
      }
    });

  }

  handleSubmit = async (): Promise<void> => {

    const isValid: boolean = this.isValid();
    
    const offlineRfs: OfflineRfsModel = { ...this.state.offlineRfs };

    if(offlineRfs.dropOff && !offlineRfs.dropOffName) {
      var dropoffResult = this.state.dropOffPoints.find(obj => { return obj.id == parseInt(offlineRfs.dropOff) })
      offlineRfs.dropOffName = (dropoffResult)? dropoffResult.name: ''
      this.setState ({ offlineRfs });
    }
    if(offlineRfs.pickUp && !offlineRfs.pickUpName) {
      var pickupResult = this.state.pickupPoints.find(obj => { return obj.id == parseInt(offlineRfs.pickUp) })
      offlineRfs.pickUpName = (pickupResult)? pickupResult.name: ''
      this.setState ({ offlineRfs });
    }

    if (!isValid) {

      offlineRfsRemote.createRfs(offlineRfs).then((resp: ApiResponse<OfflineRfsModel>) => {
        const success: OfflineRfsModel | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;
  
        if (success) {
          if(this.state.isEditMode) {
            this.props.history.push(`/create-manifest/${parseInt(this.props.match.params.id)}`);
          } else {
            this.props.history.push(`/create-manifest`);
          }
          
        }

        if (error) {
          this.props.receiveError(error);
        }
      });
    }
  }

  handleCreatePoint = (type: string): void => {

    if ((type==='pickUp' && this.state.pickUp.name !== '') || (type==='dropOff' && this.state.dropOff.name !== '')) {
      let isPickUp = (type==='pickUp')? true : false;
      let obj = (type==='pickUp')? this.state.pickUp : this.state.dropOff
      offlineRfsRemote.createPoint(isPickUp, obj).then((resp: ApiResponse<Point>) => {

        const point: Point | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;
        const offlineRfs: OfflineRfsModel = { ...this.state.offlineRfs };

        if (point) {
          if(type==='pickUp') {
            this.loadPoints('pickUp');
            offlineRfs.pickUp = (typeof point.id === "number")? point.id.toString() : offlineRfs.pickUp;
            offlineRfs.pickUpName = point.name;
            this.closeDialog('PickUp')
          } else {
            this.loadPoints('dropOff');
            offlineRfs.dropOff = (typeof point.id === "number")? point.id.toString() : offlineRfs.dropOff;
            offlineRfs.dropOffName = point.name;
            this.closeDialog('DropOff')
          }
          this.setState ({ offlineRfs });
        }

        if (error) {
          this.props.receiveError(error);
        }
      });
    }
  }

  openDialog = (type: string): void => {

    switch (type) {
      case 'PickUp':
        this.setState({ isPickUpDialogOpen: true });
        this.setState({ isDropOffDialogOpen: false });
        break;
      case 'DropOff': 
        this.setState({ isDropOffDialogOpen: true });
        this.setState({ isPickUpDialogOpen: false });
        break;
      default: break;
    }
  }

  closeDialog = (type: string): void => {

    switch (type) {
      case 'PickUp':
        this.setState({ isPickUpDialogOpen: false });
        break;
      case 'DropOff': 
        this.setState({ isDropOffDialogOpen: false });
        break;
      default: break;
    }
  }

  isValid = (): boolean => {

    const errors: any = { ...this.state.errors };
    const offlineRfs: OfflineRfsModel= { ... this.state.offlineRfs };
    let hasError: boolean = false

    Object.entries(offlineRfs).forEach(([key, value]) => {
      if (value === '') {
        //errors[key] = 'Add';
        hasError = true;
      }
    });

    this.setState({ errors });
    return hasError;
  }

  render() {

    return (
      <Fragment>
        <div className= { commonStyles.headerDummyDiv }> </div>
        <RfsSetup
          isPickUpDialogOpen={this.state.isPickUpDialogOpen}
          isDropOffDialogOpen={this.state.isDropOffDialogOpen}
          offlineRfs={ this.state.offlineRfs }
          handleChange={ this.handleChange }
          openDialog={ this.openDialog }
          closeDialog={ this.closeDialog }
          handleSubmit={ this.handleSubmit }
          errors={ this.state.errors }
          pickupPoints={ this.state.pickupPoints }
          dropOffPoints={ this.state.dropOffPoints }
          pickUp={ this.state.pickUp }
          dropOff={ this.state.dropOff }
          handleCreatePoint={ this.handleCreatePoint }
          isEditMode={ this.state.isEditMode }
          getFlights={ this.getFlights }
          flights={ this.state.flights }
        />
        
      </Fragment>
    );
  };
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user,
    ghaAwbs: state.awbsGha,
    cart: state.cart.items,
    port: state.destinationPort,
    gha_id: state.destinationGhaId,
    availableAwbPartStatuses: state.awbPartStatuses,
    manualEntryEdit: state.manualEntryEdit,
    gha: state.ghaInfo
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    receiveSuccess: (msg: string) => dispatch(receiveSuccess(msg)),
    setDestinationGha: (gha: number) => dispatch(setDestinationGha(gha)),
    clearOfflineRfsClearData: () => dispatch(offlineRfsClearData()),
    getGhaInfo: (ghaId: number) => dispatch(getGhaInfo(ghaId))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RfsContainer);
